import React, {
  useEffect,
  useRef,
} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import i18n from '../../config/i18n';
import {
  DOCTOR_ID,
  NURSE_ID,
  ASSISTANT_ID,
} from '../../constants/RoleConstants';
import { WOUND_SECTION } from '../../constants/SectionNames';
import Link from '../shared/Link';
import WoundCondition from './WoundCondition';

const styles = {
  wrapper: {
    overflowX: 'auto',
    marginBottom: '5%',
  },
  table: {
    marginBottom: 0,
  },
  thead: {
    backgroundColor: '#607484',
    color: '#FFF',
  },
  th: {
    fontSize: 23,
  },
  edit: {
    float: 'right',
  },
};


const WoundList = ({
  actions,
  medicalRecordId,
  metadata,
  onExportPDF,
  patient: { patientDetail: { wounds } },
  router,
  targetSection,
  user,
  user: { profile: { roleId } },
}) => {
  const woundSectionRef = useRef();

  useEffect(() => {
    if (targetSection === WOUND_SECTION && woundSectionRef) {
      window.scrollTo(0, woundSectionRef.current.offsetTop + 140);
    }
  }, [targetSection]);

  const prepareWoundsHtml = () => {
    if (wounds) {
      wounds.sort((w1, w2) => moment(w2.created).valueOf() - moment(w1.created).valueOf());
      return wounds.map(wound => (
        <WoundCondition
          {...wound}
          key={wound.id}
          actions={actions}
          metadata={metadata}
          user={user}
          router={router}
          onExportPDF={onExportPDF}
        />
      ));
    }
    return null;
  };

  const canCreateWounds = () => ([DOCTOR_ID, ASSISTANT_ID, NURSE_ID].indexOf(roleId) > -1);

  const {
    wrapper,
    table,
    thead,
    th,
    edit,
  } = styles;

  return (
    <div style={wrapper} className="WoundList" ref={woundSectionRef}>
      <table className="table table-responsive table-bordered" style={table}>
        <thead style={thead}>
          <tr>
            <th style={th}>
              {i18n.t('woundList')}
              <span style={edit}>
                {
                  canCreateWounds() && (
                    <div className="btn-group">
                      <Link href={`/medical-records/${medicalRecordId}/wounds-create`} router={router}>
                        <button className="btn btn-success btn-sm">
                          {i18n.t('addWound')}
                        </button>
                      </Link>
                    </div>
                  )
                }
              </span>
            </th>
          </tr>
        </thead>
      </table>
      {prepareWoundsHtml()}
    </div>
  );
};

WoundList.protoTypes = {
  actions: PropTypes.object.isRequired,
  medicalRecordId: PropTypes.number.isRequired,
  metadata: PropTypes.object.isRequired,
  onExportPDF: PropTypes.func.isRequired,
  patient: PropTypes.shape({
    patientDetail: PropTypes.shape({
      wounds: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
  }).isRequired,
  router: PropTypes.object.isRequired,
  targetSection: PropTypes.string.isRequired,
  user: PropTypes.shape({
    profile: PropTypes.shape({
      roleId: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

export default WoundList;



// WEBPACK FOOTER //
// ./src/components/patient/WoundList.js